import ZNotFound from './ZNotFound.vue'

export default ZNotFound
